document.addEventListener('DOMContentLoaded',function(){
  const videoThumbnails=document.querySelectorAll('.video-thumbnail-wrapper');
  const modalOverlay=document.querySelector('.video-modal-overlay');
  const modalClose=document.querySelector('.video-modal-close');
  const videoIframe=document.querySelector('.video-iframe');
  
  videoThumbnails.forEach(thumbnail=>{
    thumbnail.addEventListener('click',function(){
      openVideoModal(this.getAttribute('data-video-id'));
    });
  });
  
  modalClose.addEventListener('click',closeVideoModal);
  
  modalOverlay.addEventListener('click',function(event){
    if(event.target===modalOverlay)closeVideoModal();
  });
  
  document.addEventListener('keydown',function(event){
    if(event.key==='Escape')closeVideoModal();
  });
  
  function openVideoModal(videoId){
    videoIframe.setAttribute('src',`https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`);
    modalOverlay.style.display='flex';
    document.body.style.overflow='hidden';
  }
  
  function closeVideoModal(){
    videoIframe.setAttribute('src','');
    modalOverlay.style.display='none';
    document.body.style.overflow='';
  }
  
  // Ensure video boxes have equal heights on mobile
  function equalizeVideoHeights() {
    if (window.innerWidth <= 749) {
      const videoColumns = document.querySelectorAll('.video-column');
      let maxHeight = 0;
      
      // Reset heights
      videoColumns.forEach(col => {
        col.style.height = 'auto';
      });
      
      // Find max height
      videoColumns.forEach(col => {
        const height = col.offsetHeight;
        if (height > maxHeight) {
          maxHeight = height;
        }
      });
      
      // Apply max height to all
      if (maxHeight > 0) {
        videoColumns.forEach(col => {
          col.style.height = maxHeight + 'px';
        });
      }
    }
  }
  
  // Run on load and resize
  window.addEventListener('load', equalizeVideoHeights);
  window.addEventListener('resize', equalizeVideoHeights);
});
